<template>
  <div>
    <div v-for="(item, index) in values">
      <div class="col-md-12 pl-5">
        <div class="row">
          <div class="col-md-10">
            <label>Opção {{ index + 1}}</label>
            <fg-input
            v-model="item.text"
            type="text"
            @input="updateValue"
            ></fg-input>
          </div>
          <div class="col-md-2 pt-5">
            <div class="form-check">
              <input
              type="checkbox"
              class="form-check-input"
              value="1"
              v-model="item.right_answer"
              :id="'ative_' + item_id + '_' + index"
              @input="updateValue"
              />
              <label :for="'ative_' + item_id + '_' + index">Correta?</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12" v-if="showButtons">
      <button
        v-if="values.length > 1"
        class="btn btn-sm mr-3"
        @click="deleteValue()"
      ><i class="fas fa-minus fa-fw"></i> última opção</button>
      <button class="btn btn-primary btn-sm" @click="addValue()"><i class="fas fa-plus fa-fw"></i> opção</button>
    </div>
  </div>
</template>
<script>
export default {
  name: "fg-question-option",
  props: {
    showButtons: Boolean,
    immediateWatch: false,
    item_id: 0,
    value: ""
  },
  data() {
    return {
      values: [
        {
          text: "",
          right_answer: 0
        }
      ]
    };
  },
  created() {
    // usado desta forma para conseguir mostrar os valores no edit. Adicionado immediate: true para mostrar, no add esta como false.
    this.$watch('value', (newData) => {
      this.values = newData;
    },
    { 
      immediate: this.immediateWatch 
    })
  },
  // watch: {
  //   value: {
  //     handler(newData) {
  //       this.values = newData;
  //     },
  //     immediate: true,
  //   }
  // },
  methods: {
    updateValue() {
      this.$emit("input", this.values);
    },
    deleteValue() {
      let i = this.values.length - 1;
      if (i > 0) {
        this.values.splice(i, 1);
        this.$emit("input", this.values);
      }
    },
    addValue() {
      this.values.push({});
      this.$emit("input", this.values);
    }
  }
};
</script>
<style>
</style>
